var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var AppConstants = require('../../constants/AppConstants');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var UrlUtils = require('../../utils/urlUtils');
var createReactClass = require('create-react-class');
var { Input } = require('metro-ui-components');
var { Button } = require("@metro-ui/core");
var PageCase = require('../PageCase/PageCase.js');
var TOTPWidget = require('../TOTPWidget/TOTPWidget');
var InputMask = require('react-input-mask');
var Utils = require('../../utils/Utils');
var LocaleUtils = require('../../utils/localeUtils');
var ErrorCodes = require('../../utils/ErrorCodes.js');
var LoginHelper = require('../../utils/loginHelper.js');
const ForgotPasswordTabs = require('./ForgotPasswordTabs.js');
const FooterMinimal = require('../Footer/FooterMinimal.js');
const PhonePrefixes = require("../../constants/PhonePrefixes").default;
require('./forgot-password.less');
const country_code= UrlUtils.getParameterByName("country_code");
const numberDetails = PhonePrefixes.find((el) => el.key === country_code);
const prefixValue = numberDetails ? numberDetails : PhonePrefixes.find((el) => el.key === AppConstants.DEFAULT_PHONE_NUMBER_LANGUAGE);

var ForgotPassword = createReactClass({
  displayName: 'ForgotPassword',
  EmailId: '',

  getInitialState() {
    const countryCodes = AppConstants.COUNTRY_CODE_FOR_NUMBERS[this.props.countryCode] ? 
                                AppConstants.COUNTRY_CODE_FOR_NUMBERS[this.props.countryCode] : AppConstants.COUNTRY_CODE_FOR_NUMBERS[AppConstants.DEFAULT_COUNTRY_CODE];
    return {
      forgotPasswordEmailError: false,
      emailId: '',
      prefix: prefixValue.label || "",
      mobileNumber: '',
      notificationChannel: "email",
      showTOTPControl: null,
      isPhoneNumber: false,
      maskedCountryCodePhoneNumber: countryCodes.maskedCountryCodePhoneNumber,
      maskedCountryPhoneNumber: countryCodes.maskedCountryPhoneNumber,
      countryCodePhoneNumber: countryCodes.countryCodePhoneNumber,
      caretPosition: null,
      localeId: this.props.localeId,
      showSpinner: false
    };
  },

  componentDidMount: function () {
    LoginStore.addForgotPasswordChangeListener(this._onForgotPasswordChange);
    LoginActions.getUserLoginStrategy(this.props.countryCode, this.props.userType);
  },

  _onForgotPasswordChange: function () {

    let appState = LoginStore.getState();
    let props = this.props;

    if (appState.ForgotPasswordCode.status === 200) {
      this.googleAnalyticsSendEvents();
      this.setState({ forgotPasswordEmailError: false });
      this.setState({ showSpinner: false });
      if (this.state.isPhoneNumber) {
        this.setState({ mailToken: appState.ForgotPasswordCode.mailToken });
        this.setState({ showTOTPControl: AppConstants.TWO_FA_FOR_FORGOTPASSWORD });
      }
      else {
        let backToLoginUrl = window.location.protocol + "//" + window.location.host + AppConstants.Links.SIGN_IN_PAGE + "?" +
          AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, this.state.localeId) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.PREVIEW, props.preview) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + 
          UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state);

        window.location = backToLoginUrl +
          UrlUtils.appendQueryParam("emailSent", AppConstants.EmailSentCode.FORGOTPASSWORD) + 
          UrlUtils.appendQueryParam("notificationChannel", this.state.notificationChannel) +
          UrlUtils.appendQueryParam(AppConstants.UrlParams.PASSWORDLESS, UrlUtils.getParameterByName("passwordless") === 'true');
      }
    } else {
      if (this.state.isPhoneNumber) {
        this.setState({ showTOTPControl: AppConstants.TWO_FA_FOR_FORGOTPASSWORD });
      }
      else {
        const errors ={
          type: this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]),
          label: ErrorCodes[appState.ForgotPasswordCode.errorCode] || "An error has ocurred",
        }
        this.setState({ forgotPasswordEmailError: true });
        this.setState({ showSpinner: false });
        LoginActions.triggerToast(LocaleUtils.formatMessage(this.props.intl, defaultMessages, ErrorCodes[appState.ForgotPasswordCode.errorCode],
          this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]])), "error")
          Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'ForgotPassword' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, errors );
      }
    }
  },

  renderFooter: function () {
    return (
      <IntlProvider locale={this.state.localeId}
        messages={this.props.translations}>
        <FooterMinimal {...this.props} locale={ this.state.localeId} onLocalChange={this.onLocalChange} />
      </IntlProvider>
    )
  },

  handlePrefixChange(_, value) {
    this.setState({ prefix: value });
  },

  storeMobileNumber(ev, value) {
    this.setState({ mobileNumber: value });
  },

  enableEmailAndMobileTabs(){
    const { countryCode } = this.props;
    let mobileTabCountries;

    if(window.WebConstants.mobileChannelCountryList.includes("ALL")){
      return true
    }

    if (window.WebConstants.mobileChannelCountryList) {
      mobileTabCountries = window.WebConstants.mobileChannelCountryList.includes(countryCode)
    }
    return mobileTabCountries;
  },

  onLocalChange(localeId) {
    this.setState({ localeId: localeId });
  },

  onTabChange(event){
    this.setState({ notificationChannel: event });
  },

  getNumberFormat() {
    const { mobileNumber, prefix } = this.state;
    if(prefix){
      return `${prefix.replace("+", "00")}${mobileNumber}`;
    }
    return `${prefix}${mobileNumber}`;
  },

  googleAnalyticsSendEvents(){
    Utils.googleAnalyticsClickEvents('request_forgotten_password','interaction', this.props.countryCode, 'ForgotPassword' , this.props.userType, this.props.reamlId, this.props.clientId, false );
  },

  onForgotPasswordSubmit: function (evt) {
    evt.preventDefault();
    this.setState({ showSpinner: true });

    const phoneNumber= this.getNumberFormat();
    const notificationChannelValue = this.state.notificationChannel;
    
    if(notificationChannelValue === "email"){
      LoginActions.submitForgotPassword(this.EmailId, this.props, notificationChannelValue);
    }else{
      LoginActions.submitForgotPassword(phoneNumber, this.props, notificationChannelValue);
    }
  },

  onEmailChange(e) {
    var value = e.target.value;
    var caretPosition = this.state.caretPosition

    if (caretPosition && caretPosition > 0) {
      Utils.setCaretPosition("email_id", caretPosition);
      this.setState({ caretPosition: null });
    }

    if (this.props.allowMobileLogin) {
      const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)\?(\\d*)$", 'g');
      const isPhoneNumber = regEx.test(value);
      if (this.state.isPhoneNumber == true && isPhoneNumber == false) {
        value = value.replace("+", "");
      }

      if (this.state.isPhoneNumber == false && isPhoneNumber == true) {
        if (value && value.indexOf('+') == -1) {
          value = value.replace("+", "")
          value = this.state.countryCodePhoneNumber + AppConstants.LOGIN_SEPERATOR + value;
        }
        else {
          if (value && value.indexOf(AppConstants.LOGIN_SEPERATOR) == -1 && value.length == this.state.countryCodePhoneNumber.length) {
            value = value.slice(0, this.state.countryCodePhoneNumber.length)
              + AppConstants.LOGIN_SEPERATOR
              + txt1.slice(this.state.countryCodePhoneNumber.length);
          }
        }
      }

      let transformedValue = value;
      if (isPhoneNumber) {
        transformedValue = transformedValue.replace('+', '00');
        transformedValue = transformedValue.replace(AppConstants.LOGIN_SEPERATOR, '');
      }
      this.EmailId = transformedValue;
      this.setState({ emailId: value, isPhoneNumber });
    }
    else {
      this.EmailId = value.trim();
      this.setState({ emailId: value.trim() });
    }
  },

  beforeMaskedValueChange(newState, oldState, userInput) {
    var { value } = newState;
    var selection = newState.selection;
    var cursorPos = selection ? selection.start : null;

    const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)\?(\\d*)$", 'g');
    const isNotPhoneNumber = !regEx.test(userInput);

    if (userInput && this.state.isPhoneNumber == true && isNotPhoneNumber == true) { // check and remove occurance of +        
      if (cursorPos > 0)
        value = value.substring(0, cursorPos) + userInput + value.substring(cursorPos, value.length);
      else
        value = userInput + value;

      value = value.split(AppConstants.LOGIN_SEPERATOR).pop();
      var prefixLength = this.state.maskedCountryCodePhoneNumber.length + AppConstants.LOGIN_SEPERATOR.length;
      this.setState({ caretPosition: (cursorPos - prefixLength + 1) });
    }

    return {
      value,
      selection
    };
  },

  onForgotPasswordCancel: function (evt) {
    evt.preventDefault();
    this.setState({ showSpinner: false });
    let props = this.props;
    window.location = window.location.protocol + "//" + window.location.host + AppConstants.Links.SIGN_IN_PAGE + "?" +
      AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, this.state.localeId) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.PREVIEW, props.preview) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + 
      UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
      UrlUtils.appendQueryParam(AppConstants.UrlParams.PASSWORDLESS, UrlUtils.getParameterByName("passwordless") === 'true')
  },

  renderTOTPForm() {
    let props = this.props;
    let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
    let headerMessage = this.props.intl.formatMessage(defaultMessages['forgotYourPassword']);
    return (
      <div className="portraitCenteredEmployee">
        <div className="welcomeTitle">
          <span id="welcomeToMetroDigital">
            {bodyHeader}
          </span>
        </div>
        <div className="employeeBoxContainer container">
          <div className="col-md-3 col-sm-2 col-xs-0" />
          <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
            <div className="row whiteContainer larger-device-width smaller-device">
              <div className="col-xs-12 smaller-device-inside-wrap">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="form-group centreAligned loginHeader">
                      <span>{headerMessage}</span>
                    </ div>
                  </div>
                </div>
                <TOTPWidget
                  {... this.props}
                  phone={this.EmailId}
                  login={this.EmailId}
                  idToken={this.state.mailToken}
                  isForgotPasswordFlow={this.state.isPhoneNumber}
                  twoFaAuthMethod= {this.state.showTOTPControl}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-2 col-xs-0" />
        </div>
      </div>
    );
  },

  renderEmailIdField() {
    var renderNewInput = true;
    var props = this.props;
    if (props.allowMobileLogin) {
      let label = props.intl.formatMessage(defaultMessages['login.link.EmailOrMobile']);
      let maskedCountryCodePhoneNumber = this.state.maskedCountryCodePhoneNumber;
      let maskedCountryPhoneNumber = this.state.maskedCountryPhoneNumber;
      let mask = maskedCountryCodePhoneNumber + AppConstants.LOGIN_SEPERATOR + maskedCountryPhoneNumber;
      if (this.state.isPhoneNumber) {
        return (
          <span id='loginIdBox'>
            <div className="m-input m-input-email_id">
              <div className="m-label">
                <label>{label}</label>
              </div>
              <div className="m-input-elementWrapper">
                <InputMask
                  id="email_id"
                  name="email_id"
                  autoComplete="off"
                  mask={mask}
                  maskChar={''}
                  value={this.state.emailId}
                  className={"m-input-element" + (this.state.forgotPasswordEmailError ? " m-input-hasWarning" : "")}
                  autoFocus={true}
                  onChange={this.onEmailChange}
                  beforeMaskedValueChange={this.beforeMaskedValueChange} />
              </div></div>
          </span>
        )
      } else {
        return (
          <Input
            id="email_id"
            type="email"
            key="user_id"
            name="email_id"
            autoComplete="off"
            label={label}
            required={true}
            hasWarning={this.state.forgotPasswordEmailError}
            value={this.state.emailId}
            onChange={this.onEmailChange}
            onKeyUp={this.onEmailChange}
            onKeyDown={this.onEmailChange}
            autoFocus={true}
          />
        );
      }
    }
    // return old login field 
    let label = props.intl.formatMessage(defaultMessages['email']);
    return (
      <Input
        id="email_id"
        type="email"
        key="user_id"
        name="email_id"
        autoComplete="off"
        label={label}
        required={true}
        hasWarning={this.state.forgotPasswordEmailError}
        value={this.state.emailId}
        onChange={this.onEmailChange}
        onKeyUp={this.onEmailChange}
        onKeyDown={this.onEmailChange}
        autoFocus={true}
      />
    )
  },

  renderForm() {
    const forgotYourPasswordMsg1 = this.props.intl.formatMessage(defaultMessages['forgotYourPasswordMsg1']);
    const forgotYourPasswordMsg2 = this.props.intl.formatMessage(defaultMessages['forgotYourPasswordMsg2']);
    return (
      <div className="loginFieldsForgotPassword">
      <div className="blueText"> {forgotYourPasswordMsg1}</div>
      <br />
      <div className="blueText"> {forgotYourPasswordMsg2}</div>
      <br />
        <form onSubmit={this.onForgotPasswordSubmit} noValidate="novalidate">
          <div className="row form-group forgotPasswordForm loginFields">
            <div className="col-md-12 col-sm-12 col-xs-12">
              {this.renderEmailIdField()}
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="submit-button col-md-6 col-sm-6 col-xs-12">
                <Button id="submit" type="submit" kind="primaryRaised" style={{ width: "100%", marginBottom: '10px' }}  size={"large"} value="Submit" block
                  isDisabled={!this.state.emailId || this.state.showSpinner}
                  isWaiting={this.state.showSpinner}
                  >
                  {this.props.intl.formatMessage(defaultMessages['submit'])}
                </Button>
              </div>
              <div className="cancel-button col-md-6 col-sm-6 col-xs-12">
                <Button  id="Cancel" kind="secondary" size="large" value="Cancel" style={{ width: "100%" }} block onClick={this.onForgotPasswordCancel}>
                  {this.props.intl.formatMessage(defaultMessages['cancel'])}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  },

  renderForGotPassword() {
    let props = this.props;
    return (
      <div className="forgotPasswordWrapper">
        <div className="container">
          <div className="pagecontent-forgotPassword">
            <div className="row wrapperclassForgotPassword">
              <div className="col-lg-3 col-md-3 col-sm-2 col-xs-0">
              </div>
              <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                <div className="forgotPasswodContainer">
                  <div className="paragraphHeader forgotpasswordheader">
                    <h1>   {this.props.intl.formatMessage(defaultMessages['forgotYourPassword'])}</h1>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      {this.enableEmailAndMobileTabs() ?
                          <ForgotPasswordTabs 
                            onForgotPasswordSubmit={this.onForgotPasswordSubmit}
                            onForgotPasswordCancel={this.onForgotPasswordCancel}
                            phoneData={this.state.prefix && this.state.mobileNumber}
                            onTabChange={this.onTabChange}
                            children={this.renderForm()}
                            handlePrefixChange={this.handlePrefixChange}
                            storeMobileNumber={this.storeMobileNumber}
                          />
                          :  this.renderForm()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-2 col-xs-0">
              </div>
            </div>
            <div className="push"></div>
          </div>
        </div>
      </div>
    );
  },

  renderContent() {
    let renderedComponent = this.state.showTOTPControl ? this.renderTOTPForm() : this.renderForGotPassword();
    return (
      <div>
        {renderedComponent}
      </div>
    )
  },

  render: function () {
    return (
      <PageCase
        header={<Header />}
        content={this.renderContent()}
        footer={this.renderFooter()}></PageCase>
    );
  }
});

module.exports = injectIntl(ForgotPassword);
